import { en } from './en';

// For now only `en`. Later: pick locale from context/store.
export const useTranslation = () => ({ t: en });
